import { render } from "./BaseDatalist.vue?vue&type=template&id=5a511ac0"
import script from "./BaseDatalist.vue?vue&type=script&lang=js"
export * from "./BaseDatalist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__